import React from 'react';
import { createRoot } from 'react-dom/client';
import { PricingModal } from './main.js';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <div style={{ minHeight: '100vh', backgroundColor: '#1a1b1e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <PricingModal isOpen={true} onClose={() => { }} currentPlan="Suite" />
  </div>
);